export default "__VITE_PUBLIC_ASSET__e987e8f0__"